import { Location } from '@angular/common';
import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import {
  ErrorInterface,
  MetaTagsService,
  MobileDetectService,
  PostFeedInterfaceLastId,
  PostFeedService,
  PostModel,
  PostsService,
  RouterService,
  UserModel,
  UserService,
  utilsFactory,
} from '@lib/gc-common';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'mip-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
})
export class ProfileComponent implements OnInit, AfterViewInit, OnDestroy {
  loadingPosts = true;
  loadingProfile = false;
  postsList: Array<PostModel> = [];
  profile: UserModel = null;
  onRouteChange = null;
  noFeed = null;
  feedError = null;
  lastPostId = null;
  isValidBrowser = true;
  backPathReferrer = null;
  lastProfileId = null;

  // postPagination = null;

  isMobile = true;
  isDesktop = true;

  postFeedControl: PostFeedInterfaceLastId = null;

  constructor(
    private postsService: PostsService,
    private userService: UserService,
    private routerService: RouterService,
    private location: Location,
    private metaTagsService: MetaTagsService,
    private translate: TranslateService,
    private mobileDetect: MobileDetectService,
    private postFeedService: PostFeedService,
  ) {
    // console.log('profile.component->constructor(): this.postsList', this.postsList);

    this.isMobile = this.mobileDetect.isMobile();
    this.isDesktop = !this.mobileDetect.isMobile();

    this.isValidBrowser = this.mobileDetect.isValidBrowser();

  }

  ngOnInit() {
    // console.log('profile.component->ngOnInit()');

    // console.log('profile.component->ngOnInit()');
    this.onRouteChange = this.routerService.onRouteChange().subscribe(async (route) => {
      // console.log('profile.component->ngOnInit() route', route);

      try {
        let userId = route.params.userId;
        // console.log('profile.component->ngOnInit() userId', userId);

        if (!userId) {
          // return false;
          const error = <ErrorInterface>new Error(`The 'userId' was not provided!`);
          error.code = 500;
          throw error;
        }

        // console.log('profile.component->ngOnInit() userId.indexOf()', userId.indexOf('@'));

        if (userId && userId.indexOf('@') > -1) {
          userId = userId.replace('@', '');
        }

        // console.log('profile.component->ngOnInit() userId', userId);

        if (!userId || userId === 'null' || userId === 'undefined') {
          // return false;
          const error = <ErrorInterface>new Error(`The 'userId' was not provided!`);
          error.code = 500;
          throw error;
        }

        if (this.lastProfileId === userId) {
          return false;
        }

        // console.log('profile.component->ngOnInit() userId', userId);

        this.backPathReferrer = this.routerService.getGoBackReferer(this.routerService.getCurrentPathName());

        // console.log('profile.component->ngOnInit() onRouteChange', route);

        this.lastProfileId = userId;

        this.lastPostId = null;
        this.postsList = [];
        // console.log('profile.component->ngOnInit() this.postsList', this.postsList);

        this.loadingProfile = true;
        // console.log('profile.component->ngOnInit() this.loadingProfile', this.loadingProfile);

        this.profile = await this.userService.getUser(userId);
        // console.log('profile.component->ngOnInit() this.profile', this.profile);

        this.loadingProfile = false;
        // console.log('profile.component->ngOnInit() this.profile.isAuthenticated', this.profile.isAuthenticated);

        this.postFeedControl = this.postFeedService.registerFeedLastIdPagination(
          `profile-feed-${this.profile.id}`,
          this.profile.getPosts.bind(this.profile),
          { limit: 30 },
        );
        // console.log('profile.component->ngOnInit() this.postFeedControl', this.postFeedControl);

        this.postsList = this.postFeedControl.postsList;
        // console.log('profile.component->ngOnInit() this.postsList', this.postsList);

        if (this.postsList.length) {
          this.loadingPosts = false;
        }

        let pageTitle = '';

        if (this.profile.getName()) {
          pageTitle += `${this.profile.getName()} `;
        }

        pageTitle += `@${this.profile.username}`;

        // console.log('profile.component->ngOnInit() pageTitle', pageTitle);
        await this.metaTagsService.setMetaTags({
          title: pageTitle,
          description: this.profile.bio,
          image: this.profile.avatar.source,
        });

        if (utilsFactory.isBrowser) {
          // if (this.postsList.length <= 1) {
          await this.getPosts();
        }
      } catch (e) {
        
        console.error('profile.component->ngOnInit() ERROR', e);
        
        this.loadingPosts = false;

        if (e['code'] === 404 || e['code'] === 405 || e['code'] === 400) {
          await this.routerService.navigateTo('/404', {
            skipLocationChange: true,
          });
        } else if (e['code'] >= 500) {
          await this.routerService.navigateTo('/error', {
            skipLocationChange: true,
          });
        }
      }
    });
  }

  ngAfterViewInit() {
  }

  ngOnDestroy() {
    // console.log('profile.component->ngOnDestroy()', this.onRouteChange);
    this.onRouteChange.unsubscribe();

    if (this.postFeedControl) {
      // this.postFeedControl.destroy();
    }
  }

  onLogout() {
    // console.log('profile-user-actions.component->onLogout()');
    this.userService.logout();
  }

  async getPosts() {
    // console.log('profile.component->getPosts(): this.loadingPosts', this.loadingPosts);

    try {
      if (!this.isValidBrowser) {
        return;
      }

      if (this.loadingPosts && this.postsList.length) {
        await utilsFactory.waitToBeTrue('profile.component', () => this.loadingPosts === false);

        /*await new Promise(resolve => {
				 const intervalTimer = setInterval(() => {
				 if (this.loadingPosts === false) {
				 clearInterval(intervalTimer);
				 resolve();
				 }
				 }, 100);
				 });*/
      }

      this.feedError = false;
      this.loadingPosts = true;

      // console.log('profile.component->getPosts(): getItems()');
      await this.postFeedControl.pagination.getItems();
      // console.log('profile.component->getPosts(): this.postsList', this.postsList);

      if (this.postsList.length === 0) {
        this.noFeed = true;
      }

      this.loadingPosts = false;
      // console.log('profile.component->getPosts(): this.loadingPosts', this.loadingPosts);
    } catch (e) {
      this.loadingPosts = false;
      this.feedError = true;
      throw e;
    }
  }
}
